import { type User as Auth0User } from "@auth0/auth0-react";

import { type User, auth0UserIdToGiteaUserId } from "~/models/user";

// Helper function to map Auth0User to our User type
export const mapUser = (user: Auth0User | undefined): User | undefined => {
	if (!user) {
		return undefined;
	}

	const id = user.sub;
	const name = user.name;
	const email = user.email;

	if (!(id && name && email)) {
		console.log(`Auth0 returned a user but expected properties are missing`, {
			id,
			name,
			email,
		});
		return undefined;
	}

	return {
		id,
		name,
		email,
		publicEmail: user["http://api.moment.dev/public_email"] || email,
		giteaUserId: id ? auth0UserIdToGiteaUserId(id) : "",
		nickname: user.nickname || "",
		givenName: user.given_name || "",
		familyName: user.family_name || "",
		profilePicture: user.picture || "",
		updatedAt: user.updated_at || "",
		organizationID: "",
		alternateIDs: null,
		isMomentEmployee: user["http://api.moment.dev/isMoment"] || false,
	};
};
